import React from 'react';

import { QueueState } from '../../../components/queue-state';
import { Queue } from '../../../types/queue';

export function QueueStatus(props: { queue: Queue }) {
  return (
    <div>
      <QueueState showDetail queue={props.queue} />
    </div>
  );
}
